export const limitChars = (text: string, limit: number) => {
	if (limit <= 0) return ''
	return Array.from(text).slice(0, limit).join('')
}
